export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      products: 'Products',
      about: 'About',
      contact: 'Contact',
      quote: 'Get a Quote',
    },
    // Home page hero slides
    hero: {
      slide1_tag: 'Manufacturer',
      slide1_heading: 'Built for the\nHardest Floors.',
      slide1_sub: 'Industrial-grade rubber matting. Made in Kottayam, Kerala.',
      slide1_cta: 'See Products',
      
      slide2_tag: 'Anti-Fatigue',
      slide2_heading: 'Protect Your\nPeople.',
      slide2_sub: 'Reduce fatigue. Reduce accidents. Raise productivity.',
      slide2_cta: 'Explore Range',
      
      slide3_tag: 'Livestock',
      slide3_heading: 'Farm to\nFactory Floor.',
      slide3_sub: 'Cattle mats, stable mats, cage mats — all in one place.',
      slide3_cta: 'View Catalog',
    },
    // Home offerings section
    offerings: {
      eyebrow: 'What We Supply',
      heading: 'Our Product Range',
      subhead: 'From factory floors to farmyards — premium matting engineered for every environment.',
      cta_text: 'Need something custom? We handle bulk orders.',
      cta_btn: 'Request a Free Quote',
      
      category_01: 'Industrial Mats',
      category_01_desc: 'Heavy-duty rubber engineered for factories, warehouses, and production floors.',
      category_02: 'Anti-Fatigue Mats',
      category_02_desc: 'Ergonomic cushioning that cuts standing fatigue — ideal for assembly lines and workstations.',
      category_03: 'Indoor Flooring',
      category_03_desc: 'Interlocking and roll-out systems for gyms, sports halls, and commercial spaces.',
      category_04: 'Cattle Flooring',
      category_04_desc: 'Agricultural-grade rubber for livestock comfort, hoof health, and animal welfare.',
      category_05: 'Domestic Mats',
      category_05_desc: 'Entrance mats, stair treads, door mats — where function meets everyday life.',
      category_06: 'Commercial Solutions',
      category_06_desc: 'Contract-grade flooring for hotels, offices, retail, and hospitality. Bulk supply available.',
    },
    // Home quality section
    quality: {
      eyebrow: 'Why Our Mats',
      heading: 'Built to a Higher Standard',
      subhead: 'Seven core quality benchmarks. Every single mat. No exceptions.',
      
      recyclable: 'Recyclable',
      recyclable_sub: 'Eco-Friendly',
      antiSlip: 'Anti Slip',
      antiSlip_sub: 'Safety First',
      antiFatigue: 'Anti Fatigue',
      antiFatigue_sub: 'Ergonomic Comfort',
      oilResistant: 'Oil Resistant',
      oilResistant_sub: 'Industrial Grade',
      waterResistant: 'Water Resistant',
      waterResistant_sub: 'All-Weather Ready',
      nonToxic: 'Non Toxic',
      nonToxic_sub: 'Safe for All',
      fireResistant: 'Fire Resistant',
      fireResistant_sub: 'Flame Retardant',
    },
    // Products page
    products: {
      eyebrow: 'SP Industries',
      title: 'Our Complete\nProduct Range',
      sub: 'Multi-purpose flooring mats — industrial, indoor, agricultural, and domestic. Crafted to international standards in Kottayam, Kerala.',
      
      nav_industrial: 'Industrial / Anti-Fatigue',
      nav_indoor: 'Indoor Flooring',
      nav_cattle: 'Cattle Flooring',
      nav_domestic: 'Domestic & Commercial',
      
      view_specs: 'View Specs & Sizes',
      hide_specs: 'Hide Specs',
      enquire: 'Enquire →',
      
      section_products: 'Product Line',
      
      tech_specs: 'Technical Specifications',
      sizes_weights: 'Sizes & Weights',
      size: 'Size',
      weight: 'Weight',
    },
    // Footer
    footer: {
      tagline: 'Premium matting & flooring for industrial, agricultural, domestic and commercial use. Made in Kottayam, Kerala.',
      
      products_title: 'Products',
      company_title: 'Company',
      contact_title: 'Get In Touch',
      
      prod_industrial: 'Industrial Mats',
      prod_antifatigue: 'Anti-Fatigue Mats',
      prod_indoor: 'Indoor Flooring',
      prod_cattle: 'Cattle Flooring',
      prod_domestic: 'Domestic Mats',
      prod_commercial: 'Commercial Solutions',
      
      company_about: 'About Us',
      company_certifications: 'Certifications',
      company_careers: 'Careers',
      company_privacy: 'Privacy Policy',
      
      contact_address: 'Bosboom-tousaintstraat 12, 9721RH Groningen',
      contact_email: 'malabarmatseurope@gmail.com',
      contact_phone: '063754623',
      contact_kvk: 'KVK Number: 76313506',
      contact_btw: 'BTW Number: NL 003078159B36',
      contact_message: 'Send Us a Message',
      
      copyright: '© {year} VELD floorings. All rights reserved.',
      location: 'Made in Kerala, India',
    },
  },
  
  nl: {
    // Navigation
    nav: {
      home: 'Home',
      products: 'Producten',
      about: 'Over ons',
      contact: 'Contact',
      quote: 'Gratis Offerte',
    },
    // Home page hero slides
    hero: {
      slide1_tag: 'Fabrikant',
      slide1_heading: 'Gebouwd voor de\nHardste Vloeren.',
      slide1_sub: 'Industriële rubberen matten. Gemaakt in Kottayam, Kerala.',
      slide1_cta: 'Bekijk Producten',
      
      slide2_tag: 'Anti-Vermoeidheid',
      slide2_heading: 'Bescherm Je\nMensen.',
      slide2_sub: 'Verminder vermoeidheid. Verminder ongelukken. Verhoog productiviteit.',
      slide2_cta: 'Bekijk Assortiment',
      
      slide3_tag: 'Vee',
      slide3_heading: 'Van Boerderij\nNaar Fabriekshal.',
      slide3_sub: 'Koematten, stalmatten, kooimatten — alles op één plek.',
      slide3_cta: 'Bekijk Catalogus',
    },
    // Home offerings section
    offerings: {
      eyebrow: 'Wat Wij Leveren',
      heading: 'Ons Productassortiment',
      subhead: 'Van fabriekshal tot boerenerf — premium matten ontworpen voor elke omgeving.',
      cta_text: 'Wilt u iets op maat? Wij behandelen bulkbestellingen.',
      cta_btn: 'Gratis Offerte Aanvragen',
      
      category_01: 'Industriële Matten',
      category_01_desc: 'Zware rubberen matten voor fabrieken, magazijnen en productievloeren.',
      category_02: 'Anti-Vermoeidheidmatten',
      category_02_desc: 'Ergonomische demping die vervoeking verlicht — ideaal voor assemblagelinijen en werkstations.',
      category_03: 'Binnenvloeren',
      category_03_desc: 'Insteeksystemen voor gymnastieken, sporthallen en commerciële ruimten.',
      category_04: 'Veevloeren',
      category_04_desc: 'Landbouw-rubberen voor dierenwelzijn, hoefgezondheid en comfort.',
      category_05: 'Huismatten',
      category_05_desc: 'Entréematten, traptreden, deurmatten — waar functie het dagelijks leven ontmoet.',
      category_06: 'Commerciële Oplossingen',
      category_06_desc: 'Contractvloeren voor hotels, kantoren, winkels en horeca. Bulkaanbod beschikbaar.',
    },
    // Home quality section
    quality: {
      eyebrow: 'Waarom Onze Matten',
      heading: 'Gebouwd Volgens Hogere Normen',
      subhead: 'Zeven kernkwaliteitsnormen. Elke enkele mat. Geen uitzonderingen.',
      
      recyclable: 'Recycleerbaar',
      recyclable_sub: 'Milieuvriendelijk',
      antiSlip: 'Anti-Slip',
      antiSlip_sub: 'Veiligheid Eerst',
      antiFatigue: 'Anti-Vermoeidheid',
      antiFatigue_sub: 'Ergonomisch Comfort',
      oilResistant: 'Oliebestendig',
      oilResistant_sub: 'Industriële Kwaliteit',
      waterResistant: 'Waterbestendig',
      waterResistant_sub: 'Allweer Gereed',
      nonToxic: 'Niet Giftig',
      nonToxic_sub: 'Veilig Voor Iedereen',
      fireResistant: 'Brandbestendig',
      fireResistant_sub: 'Vlamvertragend',
    },
    // Products page
    products: {
      eyebrow: 'SP Industries',
      title: 'Ons Volledige\nProductAssortiment',
      sub: 'Veelzijdige vloermatten — industrieel, indoor, landbouw en huishoudelijk. Vervaardigd volgens internationale normen in Kottayam, Kerala.',
      
      nav_industrial: 'Industrieel / Anti-Vermoeidheid',
      nav_indoor: 'Binnenvloeren',
      nav_cattle: 'Veevloeren',
      nav_domestic: 'Huishoudelijk & Commercieel',
      
      view_specs: 'Bekijk Specs & Maten',
      hide_specs: 'Verberg Specs',
      enquire: 'Informeren →',
      
      section_products: 'Productlijn',
      
      tech_specs: 'Technische Specificaties',
      sizes_weights: 'Maten & Gewichten',
      size: 'Maat',
      weight: 'Gewicht',
    },
    // Footer
    footer: {
      tagline: 'Premium matten & vloeren voor industrieel, landbouw-, huishoudelijk en commercieel gebruik. Gemaakt in Kottayam, Kerala.',
      
      products_title: 'Producten',
      company_title: 'Bedrijf',
      contact_title: 'Contact Opnemen',
      
      prod_industrial: 'Industriële Matten',
      prod_antifatigue: 'Anti-Vermoeidheidmatten',
      prod_indoor: 'Binnenvloeren',
      prod_cattle: 'Veevloeren',
      prod_domestic: 'Huismatten',
      prod_commercial: 'Commerciële Oplossingen',
      
      company_about: 'Over Ons',
      company_certifications: 'Certificeringen',
      company_careers: 'Carrières',
      company_privacy: 'Privacybeleid',
      
      contact_address: 'Bosboom-tousaintstraat 12, 9721RH Groningen',
      contact_email: 'demalabarkitchen@gmail.com',
      contact_phone: '063754623',
      contact_kvk: 'KVK Nummer: 76313506',
      contact_btw: 'BTW Nummer: NL 003078159B36',
      contact_message: 'Stuur Ons een Bericht',
      
      copyright: '© {year} VELD floorings. Alle rechten voorbehouden.',
      location: 'Gemaakt in Kerala, India',
    },
  },
  
  de: {
    // Navigation
    nav: {
      home: 'Startseite',
      products: 'Produkte',
      about: 'Über uns',
      contact: 'Kontakt',
      quote: 'Kostenlos Angebot',
    },
    // Home page hero slides
    hero: {
      slide1_tag: 'Hersteller',
      slide1_heading: 'Gebaut für die\nHärtesten Böden.',
      slide1_sub: 'Industrielle Gummimatten. Hergestellt in Kottayam, Kerala.',
      slide1_cta: 'Produkte Ansehen',
      
      slide2_tag: 'Ermüdungsfreier',
      slide2_heading: 'Schützen Sie Ihre\nMitarbeiter.',
      slide2_sub: 'Reduzieren Sie Müdigkeit. Senken Sie Unfallzahlen. Erhöhen Sie Produktivität.',
      slide2_cta: 'Sortiment Erkunden',
      
      slide3_tag: 'Viehbestand',
      slide3_heading: 'Vom Stall bis zur\nProduktionshalle.',
      slide3_sub: 'Kuhmatten, Stallmatten, Käfigmatten — alles an einem Ort.',
      slide3_cta: 'Katalog Ansehen',
    },
    // Home offerings section
    offerings: {
      eyebrow: 'Was Wir Anbieten',
      heading: 'Unser Produktsortiment',
      subhead: 'Von Fabrikhallen bis zu Bauernhöfen — hochwertige Matten für jede Umgebung.',
      cta_text: 'Benötigen Sie etwas Individuelles? Wir bearbeiten Großbestellungen.',
      cta_btn: 'Kostenloses Angebot Anfordern',
      
      category_01: 'Industriematten',
      category_01_desc: 'Strapazierfähige Gummimatten für Fabriken, Lagerhäuser und Produktionshallen.',
      category_02: 'Ermüdungsfreie Matten',
      category_02_desc: 'Ergonomische Polsterung reduziert Ermüdung — ideal für Fließbänder und Arbeitsplätze.',
      category_03: 'Bodenfliesen',
      category_03_desc: 'Stecksysteme für Fitnessstudios, Sporthallen und kommerzielle Räume.',
      category_04: 'Stallmatten',
      category_04_desc: 'Landwirtschaftliches Gummi für Tierkomfort, Hufgesundheit und Wohlbefinden.',
      category_05: 'Haushaltsmatten',
      category_05_desc: 'Eingangsmatte, Trittstufen, Fußmatten — wo Funktion den Alltag trifft.',
      category_06: 'Kommerzielle Lösungen',
      category_06_desc: 'Vertragsbeläge für Hotels, Büros, Einzelhandel und Gastronomie. Großmengen verfügbar.',
    },
    // Home quality section
    quality: {
      eyebrow: 'Warum Unsere Matten',
      heading: 'Nach Höchsten Standards Gefertigt',
      subhead: 'Sieben Kernqualitätsrichtlinien. Jede einzelne Matte. Keine Ausnahmen.',
      
      recyclable: 'Recycelbar',
      recyclable_sub: 'Umweltfreundlich',
      antiSlip: 'Rutschfest',
      antiSlip_sub: 'Sicherheit An Erster Stelle',
      antiFatigue: 'Ermüdungsfrei',
      antiFatigue_sub: 'Ergonomischer Komfort',
      oilResistant: 'Ölbeständig',
      oilResistant_sub: 'Industrielle Klasse',
      waterResistant: 'Wasserfest',
      waterResistant_sub: 'Wetterfest',
      nonToxic: 'Ungiftig',
      nonToxic_sub: 'Sicher Für Alle',
      fireResistant: 'Feuerbeständig',
      fireResistant_sub: 'Flammhemmend',
    },
    // Products page
    products: {
      eyebrow: 'SP Industries',
      title: 'Unsere Komplette\nProduktpalette',
      sub: 'Vielseitige Bodenmatten — industriell, innen, landwirtschaftlich und privat. Nach internationalen Standards in Kottayam, Kerala gefertigt.',
      
      nav_industrial: 'Industrie / Ermüdungsfrei',
      nav_indoor: 'Bodenfliesen',
      nav_cattle: 'Stallmatten',
      nav_domestic: 'Haushalt & Gewerbe',
      
      view_specs: 'Specs & Größen Ansehen',
      hide_specs: 'Specs Ausblenden',
      enquire: 'Anfragen →',
      
      section_products: 'Produktlinie',
      
      tech_specs: 'Technische Spezifikationen',
      sizes_weights: 'Größen & Gewichte',
      size: 'Größe',
      weight: 'Gewicht',
    },
    // Footer
    footer: {
      tagline: 'Premium-Matten und -Beläge für industrielle, landwirtschaftliche, häusliche und kommerzielle Anwendungen. Hergestellt in Kottayam, Kerala.',
      
      products_title: 'Produkte',
      company_title: 'Unternehmen',
      contact_title: 'Kontakt',
      
      prod_industrial: 'Industriematten',
      prod_antifatigue: 'Ermüdungsfreie Matten',
      prod_indoor: 'Bodenfliesen',
      prod_cattle: 'Stallmatten',
      prod_domestic: 'Haushaltsmatten',
      prod_commercial: 'Kommerzielle Lösungen',
      
      company_about: 'Über Uns',
      company_certifications: 'Zertifizierungen',
      company_careers: 'Karrieren',
      company_privacy: 'Datenschutz',
      
      contact_address: 'Bosboom-tousaintstraat 12, 9721RH Groningen',
      contact_email: 'malabarmatseurope@gmail.com',
      contact_phone: '063754623',
      contact_kvk: 'KVK Nummer: 76313506',
      contact_btw: 'USt-IdNr.: NL 003078159B36',
      contact_message: 'Senden Sie Uns eine Nachricht',
      
      copyright: '© {year} VELD floorings. Alle Rechte vorbehalten.',
      location: 'Hergestellt in Kerala, Indien',
    },
  },
  
  ar: {
    // Navigation
    nav: {
      home: 'الرئيسية',
      products: 'المنتجات',
      about: 'معلومات عنا',
      contact: 'اتصل بنا',
      quote: 'احصل على عرض سعر',
    },
    // Home page hero slides
    hero: {
      slide1_tag: 'الشركة المصنعة',
      slide1_heading: 'مصنوع للأرضيات\nالأصعب.',
      slide1_sub: 'حصائر مطاطية من الدرجة الصناعية. مصنوع في كوتايام، كيرالا.',
      slide1_cta: 'عرض المنتجات',
      
      slide2_tag: 'مضاد للإرهاق',
      slide2_heading: 'حماية\nموظفيك.',
      slide2_sub: 'قلل الإرهاق. قلل الحوادث. زد الإنتاجية.',
      slide2_cta: 'استكشف المجموعة',
      
      slide3_tag: 'الثروة الحيوانية',
      slide3_heading: 'من المزرعة إلى\nأرضية المصنع.',
      slide3_sub: 'حصائر البقر، حصائر الحظائر، حصائر الأقفاص — كل شيء في مكان واحد.',
      slide3_cta: 'عرض الكتالوج',
    },
    // Home offerings section
    offerings: {
      eyebrow: 'ما نوفره',
      heading: 'نطاق منتجاتنا',
      subhead: 'من أرضيات المصانع إلى ساحات المزارع — حصائر متميزة مصممة لكل بيئة.',
      cta_text: 'هل تريد شيئاً مخصصاً؟ نتعامل مع الطلبات الكبيرة.',
      cta_btn: 'طلب عرض سعر مجاني',
      
      category_01: 'حصائر صناعية',
      category_01_desc: 'حصائر مطاطية ثقيلة الواجب مصممة للمصانع والمستودعات وأرضيات الإنتاج.',
      category_02: 'حصائر مضادة للإرهاق',
      category_02_desc: 'التوسيد الإرغونومي الذي يقلل الإرهاق من الوقوف — مثالي لخطوط التجميع ومحطات العمل.',
      category_03: 'أرضيات داخلية',
      category_03_desc: 'أنظمة قابلة للتشابك والرول لقاعات الألعاب الرياضية والقاعات الرياضية والمساحات التجارية.',
      category_04: 'أرضيات الماشية',
      category_04_desc: 'مطاط من الدرجة الزراعية لراحة الثروة الحيوانية وصحة الحوافر والرعاية الحيوانية.',
      category_05: 'حصائر منزلية',
      category_05_desc: 'حصائر المدخل، درجات السلالم، حصائر الأبواب — حيث تلتقي الوظيفة بالحياة اليومية.',
      category_06: 'الحلول التجارية',
      category_06_desc: 'أرضيات من الدرجة التعاقدية للفنادق والمكاتب والبيع بالتجزئة والضيافة. الإمدادات الضخمة متاحة.',
    },
    // Home quality section
    quality: {
      eyebrow: 'لماذا حصائرنا',
      heading: 'مبني بمعايير أعلى',
      subhead: 'سبع معايير جودة أساسية. كل حصيرة واحدة. بلا استثناءات.',
      
      recyclable: 'قابل لإعادة التدوير',
      recyclable_sub: 'صديق للبيئة',
      antiSlip: 'مضاد الانزلاق',
      antiSlip_sub: 'السلامة أولاً',
      antiFatigue: 'مضاد للإرهاق',
      antiFatigue_sub: 'الراحة الإرغونومية',
      oilResistant: 'مقاوم للزيت',
      oilResistant_sub: 'درجة صناعية',
      waterResistant: 'مقاوم للماء',
      waterResistant_sub: 'جاهز لجميع الأحوال',
      nonToxic: 'غير سام',
      nonToxic_sub: 'آمن للجميع',
      fireResistant: 'مقاوم للحريق',
      fireResistant_sub: 'مخيف اللهب',
    },
    // Products page
    products: {
      eyebrow: 'VELD floorings',
      title: 'نطاق المنتجات\nالكامل لدينا',
      sub: 'حصائر أرضية متعددة الأغراض — صناعية وداخلية وزراعية ومنزلية. مصنوعة وفقاً للمعايير الدولية في كوتايام، كيرالا.',
      
      nav_industrial: 'الصناعة / مضاد للإرهاق',
      nav_indoor: 'أرضيات داخلية',
      nav_cattle: 'أرضيات الماشية',
      nav_domestic: 'منزلي وتجاري',
      
      view_specs: 'عرض المواصفات والأحجام',
      hide_specs: 'إخفاء المواصفات',
      enquire: 'الاستفسار →',
      
      section_products: 'خط المنتجات',
      
      tech_specs: 'المواصفات التقنية',
      sizes_weights: 'الأحجام والأوزان',
      size: 'الحجم',
      weight: 'الوزن',
    },
    // Footer
    footer: {
      tagline: 'حصائر وأرضيات متميزة للاستخدام الصناعي والزراعي والمنزلي والتجاري. مصنوع في كوتايام، كيرالا.',
      
      products_title: 'المنتجات',
      company_title: 'الشركة',
      contact_title: 'تواصل معنا',
      
      prod_industrial: 'حصائر صناعية',
      prod_antifatigue: 'حصائر مضادة للإرهاق',
      prod_indoor: 'أرضيات داخلية',
      prod_cattle: 'أرضيات الماشية',
      prod_domestic: 'حصائر منزلية',
      prod_commercial: 'الحلول التجارية',
      
      company_about: 'معلومات عنا',
      company_certifications: 'الشهادات',
      company_careers: 'الوظائف',
      company_privacy: 'سياسة الخصوصية',
      
      contact_address: 'Bosboom-tousaintstraat 12, 9721RH Groningen',
      contact_email: 'demalabarkitchen@gmail.com',
      contact_phone: '063754623',
      contact_kvk: 'رقم KVK: 76313506',
      contact_btw: 'رقم BTW: NL 003078159B36',
      contact_message: 'أرسل لنا رسالة',
      
      copyright: '© {year} SP Industries. جميع الحقوق محفوظة.',
      location: 'مصنوع في كيرالا، الهند',
    },
  },
}